var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.507 17.34a1.619 1.619 0 10-.001 3.237 1.619 1.619 0 000-3.237M20.44 17.34a1.619 1.619 0 100 3.237 1.619 1.619 0 000-3.237"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.826 25.688l1.433-1.614h7.429l1.433 1.614H10.826zm-2.285-3.614h14.865V15.51H8.541v6.563zm0-14.426h14.865V6.074H8.541v1.574zm8.432 5.862h6.433V9.648h-6.433v3.862zm-8.432 0h6.433V9.648H8.541v3.862zm13.823 10.564h2.042a1 1 0 001-1v-18a1 1 0 00-1-1H7.541a1 1 0 00-1 1v18a1 1 0 001 1h2.042L5.21 29h2.675l1.165-1.312h13.847L24.062 29h2.675l-4.373-4.926z"
  })))));
}

export default SvgIconStation;